import React from 'react'
import {
  Document,
  Page,
  View,
  Text,
  Font,
  StyleSheet,
  Image,
} from '@react-pdf/renderer'
import { Roboto } from '../../../fonts'
import { adress } from '../../../api/waterAdress'
import Win1Icon from '../../../images/win_1.png'
import Win2Icon from '../../../images/win_2.png'
import Win3Icon from '../../../images/win_3.png'

Font.register({
  family: 'Roboto',
  fonts: [
    { src: Roboto.normal, fontWeight: 'normal' },
    { src: Roboto.bold, fontWeight: 'bold' },
  ],
})
const colorsector = [
  '',
  '#FF2C32',
  '#FF2C32',
  '#139FEC',
  '#139FEC',
  '#139FEC',
  '#FF2C32',
  '7',
  '#FF2C32',
  '#139FEC',
  '#139FEC',
  '#FF2C32',
  '#FF2C32',
  '13',
  '14',
  '15',
  '16',
  '17',
  '#FF2C32',
  '#FF2C32',
  '#139FEC',
  '#139FEC',
  '#139FEC',
  '#139FEC',
  '#139FEC',
  '#FF2C32',
  '26',
  '#FF2C32',
  '#FF2C32',
  '#FF2C32',
  '30',
  '31',
  '32',
  '33',
  '34',
  '35',
  '36',
  '#FF2C32',
  '#FF2C32',
  '#139FEC',
  '#139FEC',
  '#139FEC',
  '#139FEC',
  '#139FEC',
  '#139FEC',
  '#FF2C32',
  '#FF2C32',
]
const styles = StyleSheet.create({
  page: {
    flexDirection: 'column',
    padding: 20,
    fontFamily: 'Roboto',
  },
  header: {
    flexDirection: 'row',
    alignItems: 'center',
    marginBottom: 15,
    gap: 20,
  },
  logo: {
    width: 70,
    height: 'auto',
  },
  logoContainer: {
    flexDirection: 'row',
    justifyContent: 'center',
    alignItems: 'center',
    flexWrap: 'wrap',
    gap: 15,
    marginTop: 20,
    marginBottom: 10,
  },
  logoSmall: {
    height: 30,
    width: 'auto',
  },
  headerTextContainer: {
    flexGrow: 1,
    justifyContent: 'center',
  },
  headerText: {
    fontSize: 8,
    marginVertical: 1,
    lineHeight: 1.2,
    flexGrow: 1,
    width: '75%',
    flexWrap: 'wrap',
  },
  title: {
    width: '75%',
    textAlign: 'center',
    fontSize: 14,
    marginBottom: 10,
    fontWeight: 'bold',
    textTransform: 'uppercase',
  },

  tableColHeader: {
    padding: 2,
    borderStyle: 'solid',
    borderWidth: 0.3,
    borderColor: '#000',
    justifyContent: 'center', // по вертикали
  },

  tableText: {
    fontSize: 8,
    textAlign: 'center',
  },
  tableCol: {
    borderStyle: 'solid',
    borderWidth: 0.4,
    borderColor: '#000',
    padding: 2,
    fontSize: 8,
    textAlign: 'center',
  },
  tieNote: {
    fontSize: 6,
    color: '#666',
    textAlign: 'center',
  },
})
const PairTournamentProtocolPDF = ({
  allLogo,
  mainLogo,
  data,
  administrator,
  tournament,
  date,
  totalFishCount,
  totalWeight,
  averageFishWeight,
  biggestFish,
  isfinish,
}) => {
  console.log('tournament', tournament)
  console.log('datadatadatadata', data)
  function formatWeight(weight) {
    return weight.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ' ')
  }

  return (
    <Document style={{ margin: 0 }} scale={0.9}>
      <Page
        size="A4"
        style={{
          paddingBottom: 30,
          paddingRight: 20,
          paddingLeft: 20,
          paddingTop: 20,
          fontFamily: 'Roboto',
        }}
      >
        <View style={styles.header}>
          {mainLogo && <Image src={mainLogo} style={styles.logo} />}
          <View style={styles.headerTextContainer}>
            <Text style={styles.title}>{tournament.tournament_name}</Text>
            <Text style={styles.headerText}>
              Водоём:{' '}
              <Text style={{ fontWeight: 'bold' }}>
                {' '}
                {tournament.water_body} {adress(tournament.water_id)}
              </Text>
            </Text>
            <Text style={styles.headerText}>
              Дата проведения:{' '}
              <Text style={{ fontWeight: 'bold' }}>
                {tournament.start_date} - {tournament.end_date}
              </Text>
            </Text>
            <Text style={styles.headerText}>
              Дата составления:{' '}
              <Text style={{ fontWeight: 'bold' }}>{date}</Text>
            </Text>
          </View>
        </View>

        <Text
          style={{
            fontSize: 12,

            textAlign: 'center',
            marginBottom: 1,
          }}
        >
          {isfinish ? (
            <> ПРОТОКОЛ ТЕХНИЧЕСКИХ РЕЗУЛЬТАТОВ СОРЕВНОВАНИЙ</>
          ) : (
            <> ИНФОРМАЦИОННЫЙ ПРОТОКОЛ ПРОМЕЖУТОЧНЫХ РЕЗУЛЬТАТОВ СОРЕВНОВАНИЙ</>
          )}
        </Text>
        <Text style={{ fontSize: 10, textAlign: 'center', marginBottom: 13 }}>
          Ловля карпа – парные соревнования (мужчины, женщины), номер - код
          дисциплины 0920151811Л
        </Text>

        <View>
          <View
            style={{
              width: '100%',
              borderStyle: 'solid',
              borderWidth: 0.3,
              borderColor: '#000',
            }}
          >
            <View
              style={{
                height: '20px',
                flexDirection: 'row',
                alignItems: 'stretch', // важно!
              }}
            >
              <View style={[styles.tableColHeader, { width: '8%' }]}>
                <Text style={styles.tableText}>Место</Text>
              </View>
              <View style={[styles.tableColHeader, { width: '32%' }]}>
                <Text style={[styles.tableText, { textAlign: 'left' }]}>
                  Команда (пара), состав (Ф.И.О./разряд)
                </Text>
              </View>
              <View style={[styles.tableColHeader, { width: '8%' }]}>
                <Text style={styles.tableText}>Cектор</Text>
              </View>
              <View style={[styles.tableColHeader, { width: '8%' }]}>
                <Text style={styles.tableText}>Кол-во</Text>
              </View>
              <View style={[styles.tableColHeader, { width: '12%' }]}>
                <Text style={styles.tableText}>Общий вес</Text>
              </View>
              <View style={[styles.tableColHeader, { width: '12%' }]}>
                <Text style={styles.tableText}>Крупная рыба</Text>
              </View>
              <View style={[styles.tableColHeader, { width: '12%' }]}>
                <Text style={styles.tableText}>Средний вес</Text>
              </View>
              <View style={[styles.tableColHeader, { width: '8%' }]}>
                <Text style={styles.tableText}>До лидера</Text>
              </View>
            </View>
          </View>
        </View>

        {data.map((item, index) => (
          <View key={index} wrap={false}>
            <View
              style={{
                flexDirection: 'row',
                alignItems: 'stretch', // важно для одинаковой высоты 8FBC8F
                backgroundColor:
                  item.overallRank < 4
                    ? '#fff'
                    : item.totalWeight === 0
                      ? '#fff'
                      : '#fff',
              }}
            >
              {/* Место / медали */}
              {/* {isfinish && item.overallRank <= 3 ? (
                <View
                  style={[
                    styles.tableColHeader,
                    {
                      width: '8%',
                      justifyContent: 'center',
                      alignItems: 'center',
                      paddingVertical: 2,
                    },
                  ]}
                >
                  <Image
                    src={
                      item.overallRank === 1
                        ? Win1Icon
                        : item.overallRank === 2
                          ? Win2Icon
                          : Win3Icon
                    }
                    style={{ width: 13, height: 13 }}
                  />
                </View>
              ) : ( */}
              <View style={[styles.tableColHeader, { width: '8%' }]}>
                <Text style={styles.tableText}>{item.overallRank}</Text>
              </View>
              {/* )} */}
              {/* Команда */}
              <View
                style={[
                  styles.tableColHeader,
                  { width: '32%', alignItems: 'flex-start' },
                ]}
              >
                <Text style={[styles.tableText, { textAlign: 'left' }]}>
                  <Text style={{ fontWeight: 'bold' }}>{item.teamName}</Text>
                  {'\n'}
                  {item.sp}
                </Text>
              </View>
              {/* Сектор */}
              <View
                style={[
                  styles.tableColHeader,
                  {
                    width: '8%',
                    backgroundColor:
                      tournament.count_cups > 1
                        ? colorsector[item.sector]
                        : '#FFFFFF',
                    // item.zona === 'А'
                    //   ? '#FF2C32' // Красный
                    //   : item.zona === 'Б'
                    //     ? '#139FEC' // Синий
                    //     : item.zona === 'В'
                    //       ? '#FFFB14' // Желтый
                    //       : '#FFFFFF', // Белый (по умолчанию)
                  },
                ]}
              >
                <Text style={styles.tableText}>{item.sector}</Text>
              </View>
              {/* Кол-во */}
              <View style={[styles.tableColHeader, { width: '8%' }]}>
                <Text style={styles.tableText}>
                  {formatWeight(item.fishCount)}
                </Text>
              </View>
              {/* Общий вес */}
              <View style={[styles.tableColHeader, { width: '12%' }]}>
                <Text style={styles.tableText}>
                  {formatWeight(item.totalWeight)}
                </Text>
              </View>
              {/* Крупная рыба */}
              <View style={[styles.tableColHeader, { width: '12%' }]}>
                <Text style={styles.tableText}>
                  {formatWeight(item.biggestFish)}
                </Text>
              </View>
              {/* Средний вес */}
              <View style={[styles.tableColHeader, { width: '12%' }]}>
                <Text style={styles.tableText}>
                  {formatWeight(item.averageWeight)}
                </Text>
              </View>
              {/* До лидера */}
              <View style={[styles.tableColHeader, { width: '8%' }]}>
                <Text style={styles.tableText}>
                  {formatWeight(item.weightDifference)}
                </Text>
              </View>
            </View>
          </View>
        ))}

        <View
          style={{ borderWidth: 0.1, borderColor: '#fff', marginBottom: 0 }}
        >
          <View
            style={{
              flexDirection: 'row',
              backgroundColor: '#fff',
              paddingTop: 2,
            }}
          >
            <Text
              style={{
                width: '8%',
                textAlign: 'center',
                fontSize: 8,
                fontWeight: 'bold',
                padding: 2,
              }}
            ></Text>
            <Text
              style={{
                width: '32%',
                fontSize: 8,
                padding: 2,
                textAlign: 'right',
              }}
            >
              ВСЕГО
            </Text>
            <Text
              style={{
                width: '8%',
                textAlign: 'center',
                fontSize: 8,
                padding: 2,
              }}
            ></Text>
            <Text
              style={{
                height: '100%',
                width: '8%',
                textAlign: 'center',
                fontSize: 8,
                padding: 2,
              }}
            >
              {formatWeight(totalFishCount)}
            </Text>
            <Text
              style={{
                width: '12%',
                textAlign: 'center',
                fontSize: 8,
                padding: 2,
              }}
            >
              {formatWeight(totalWeight)}
            </Text>
            <Text
              style={{
                width: '12%',
                textAlign: 'center',
                fontSize: 8,
                padding: 2,
              }}
            ></Text>
            <Text
              style={{
                width: '12%',
                textAlign: 'center',
                fontSize: 8,
                padding: 2,
              }}
            >
              {formatWeight(averageFishWeight)}
            </Text>
            <Text
              style={{
                width: '8%',
                textAlign: 'center',
                fontSize: 8,
                padding: 2,
              }}
            ></Text>
          </View>
        </View>

        <View
          style={{
            flexDirection: 'row',
            justifyContent: 'space-between',
            marginTop: 10,
          }}
        >
          <View style={{ width: '50%' }}>
            <Text style={{ fontSize: '8px' }}>
              Самая крупная рыба: {formatWeight(biggestFish.weight)}
            </Text>
          </View>
        </View>

        <View
          style={{
            flexDirection: 'row',
            justifyContent: 'space-between',
            marginTop: 40,
          }}
        >
          <View
            style={{
              width: '35%',
              borderTopWidth: 1,
              borderTopStyle: 'solid',
              textAlign: 'center',
            }}
          >
            <Text style={{ fontSize: '8px', textAlign: 'center' }}>
              {administrator[0]?.surname +
                ' ' +
                administrator[0]?.name +
                ' ' +
                administrator[0]?.patronymic +
                ' (' +
                administrator[0]?.role +
                ', ' +
                administrator[0]?.rank +
                ') '}
            </Text>
          </View>
          <View
            style={{
              width: '35%',
              borderTopWidth: 1,
              borderTopStyle: 'solid',
              textAlign: 'center',
            }}
          >
            <Text style={{ fontSize: '8px', textAlign: 'center' }}>
              {administrator[1]?.surname +
                ' ' +
                administrator[1]?.name +
                ' ' +
                administrator[1]?.patronymic +
                ' (' +
                administrator[1]?.role +
                ', ' +
                administrator[1]?.rank +
                ') '}
            </Text>
          </View>
          <View
            style={{
              width: '20%',
              borderTopWidth: 1,
              borderTopStyle: 'solid',
              textAlign: 'center',
            }}
          >
            <Text style={{ fontSize: '8px', textAlign: 'center' }}>Дата</Text>
          </View>
        </View>

        <View style={styles.logoContainer}>
          {allLogo.map((item, index) => (
            <Image key={index} src={item.url} style={styles.logoSmall} />
          ))}
        </View>
      </Page>
    </Document>
  )
}

export default PairTournamentProtocolPDF
